import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/auth.slice";
import supplierReducer from "./suppliers/suppliers.slice";
import dashboardReducer from "./dashboard/dashboard.slice";
import userReducer from "./user/user.slice";
import shipmentReducer from "./shipment/shipment.slice";
import campaignReducer from "./campaign/campaign.slice";
import donationReducer from "./donation/donation.slice";

export const store = configureStore({
	reducer: {
		auth: authReducer,
		suppliers: supplierReducer,
		dashboard: dashboardReducer,
		user: userReducer,
		shipment: shipmentReducer,
		campaign: campaignReducer,
		donation: donationReducer,
	},
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
